import { SortingType } from 'constants/index';

import { ContractField } from './types';

export const DEFAULT_SORT = {
    field: ContractField.STATUS,
    type: SortingType.ASC,
};
